import * as React from 'react';

import * as style from './ReviewsList.css';

export interface IReviewsListProps {
  children: React.ReactElement[];
}

export const ReviewsList = (props: IReviewsListProps) => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
